module.exports = __webpack_public_path__ + "media/images/img_mv_sp-34226e2a823d61f05b68bdbf95ba935a.png";